import { createSelector } from 'reselect';
 
const selectEventTickets = (state: any) => state.eventTickets;


export const selectEventTicketsCurrentItem = createSelector([selectEventTickets], (eventTickets) => eventTickets.current);

export const selectEventTicketsListItems = createSelector([selectEventTickets], (eventTickets) => eventTickets.list);

export const selectEventTicketsItemById = (itemId: any) =>
    createSelector(selectEventTicketsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEventTicketsQueryItems = createSelector([selectEventTickets], (eventTickets) => eventTickets.query);


export const selectEventTicketsCreatedItem = createSelector([selectEventTickets], (eventTickets) => eventTickets.create);

export const selectEventTicketsUpdatedItem = createSelector([selectEventTickets], (eventTickets) => eventTickets.update);

export const selectEventTicketsReadItem = createSelector([selectEventTickets], (eventTickets) => eventTickets.read);

export const selectEventTicketsDeletedItem = createSelector([selectEventTickets], (eventTickets) => eventTickets.delete);

export const selectEventTicketsSearchedItems = createSelector([selectEventTickets], (eventTickets) => eventTickets.search);

export const selectEventTicketsItemsCount = createSelector([selectEventTickets], (eventTickets) => eventTickets.count);

export const selectEventTicketsItemsFilter = createSelector([selectEventTickets], (eventTickets) => eventTickets.filter);